import { StyledRegulations } from './styles';

export const RegulationsContainer = StyledRegulations;
